import { BaseUserResponseModel } from "app/based/baseApiModel/baseUserModel/BaseUserResponseModel";

export class ActionLogDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  name?: string;
  code?: string;
  type?: number;
  status?: number;
  note?: string | null;
  order?: string;
  path?: string;
  input?: string;
  output?: string;
  user?: BaseUserResponseModel;

  constructor(data?: Partial<ActionLogDetailEntity>) {
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.name = data?.name;
    this.code = data?.code;
    this.type = data?.type;
    this.status = data?.status;
    this.note = data?.note;
    this.order = data?.order;
    this.path = data?.path;
    this.input = data?.input;
    this.output = data?.output;
    this.user = data?.user;
  }
}
